import { render, staticRenderFns } from "./CapacitacionSeleccionTab.vue?vue&type=template&id=52a6c1c2&"
import script from "./CapacitacionSeleccionTab.vue?vue&type=script&lang=js&"
export * from "./CapacitacionSeleccionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports